import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { TTransactionStatusesState } from '../../types'
import { moneyFlowService } from '../../../services'
import { parseHttpError } from '../../utils'
import { parseTransactionStatuses } from './utils'
import { selectors } from './selectors'
import { transactionStatusesAdapter } from './adapter'

const name = 'transactionStatuses'

const initialState: TTransactionStatusesState = {
    ...transactionStatusesAdapter.getInitialState(),
    isFetching: false
}

const fetch = createAsyncThunk(
    `${name}/fetch`,
    async () => {
        return parseTransactionStatuses(await moneyFlowService.fetchTransactionStatuses())
    },
    {
        serializeError: parseHttpError
    }
)


const slice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(fetch.pending, (state) => {
                state.isFetching = true
                state.fetchError = undefined
            })
            .addCase(fetch.fulfilled, (state, action) => {
                state.isFetching = false
                transactionStatusesAdapter.setAll(state, action.payload)
            })
            .addCase(fetch.rejected, (state, action) => {
                state.isFetching = false
                state.fetchError = action.error
            })
})

export const transactionStatuses = {
    name: slice.name,
    actions: {
        fetch,
    },
    reducer: slice.reducer,
    selectors,
}